// Redux slice for gamification state (gems and coins)
import { createSlice } from '@reduxjs/toolkit'

// Initialize state from sessionStorage
const getInitialState = () => {
  if (typeof window === 'undefined') {
    return {
      coins: 0,
      gems: 0,
      readBlogs: [],
      testingMode: false
    }
  }

  const savedCoins = sessionStorage.getItem('tr-gamification-coins')
  const savedGems = sessionStorage.getItem('tr-gamification-gems')
  const savedReadBlogs = sessionStorage.getItem('tr-gamification-read-blogs')
  const savedTestingMode = sessionStorage.getItem('tr-gamification-testing-mode')

  return {
    coins: savedCoins ? parseInt(savedCoins, 10) : 0,
    gems: savedGems ? parseInt(savedGems, 10) : 0,
    readBlogs: savedReadBlogs ? JSON.parse(savedReadBlogs) : [],
    testingMode: savedTestingMode === 'true'
  }
}

const gamificationSlice = createSlice({
  name: 'gamification',
  initialState: getInitialState(),
  reducers: {
    addCoins: (state, action) => {
      const amount = action.payload || 1
      state.coins += amount
      if (typeof window !== 'undefined') {
        sessionStorage.setItem('tr-gamification-coins', state.coins.toString())
      }
    },
    addGems: (state, action) => {
      const amount = action.payload || 1
      state.gems += amount
      if (typeof window !== 'undefined') {
        sessionStorage.setItem('tr-gamification-gems', state.gems.toString())
      }
    },
    deductGems: (state, action) => {
      const amount = action.payload || 1
      if (state.gems >= amount) {
        state.gems -= amount
        if (typeof window !== 'undefined') {
          sessionStorage.setItem('tr-gamification-gems', state.gems.toString())
        }
      } else {
        console.warn('Redux: Not enough gems to deduct. Current:', state.gems, 'Required:', amount)
      }
    },
    setGems: (state, action) => {
      state.gems = action.payload
      if (typeof window !== 'undefined') {
        sessionStorage.setItem('tr-gamification-gems', state.gems.toString())
      }
    },
    setCoins: (state, action) => {
      state.coins = action.payload
      if (typeof window !== 'undefined') {
        sessionStorage.setItem('tr-gamification-coins', state.coins.toString())
      }
    },
    markBlogAsRead: (state, action) => {
      const blogId = action.payload
      if (!state.readBlogs.includes(blogId)) {
        state.readBlogs.push(blogId)
        if (typeof window !== 'undefined') {
          sessionStorage.setItem('tr-gamification-read-blogs', JSON.stringify(state.readBlogs))
        }
      }
    },
    setTestingMode: (state, action) => {
      state.testingMode = action.payload
      if (typeof window !== 'undefined') {
        sessionStorage.setItem('tr-gamification-testing-mode', action.payload.toString())
      }
    },
    syncFromStorage: (state) => {
      if (typeof window !== 'undefined') {
        const savedCoins = sessionStorage.getItem('tr-gamification-coins')
        const savedGems = sessionStorage.getItem('tr-gamification-gems')
        const savedReadBlogs = sessionStorage.getItem('tr-gamification-read-blogs')
        const savedTestingMode = sessionStorage.getItem('tr-gamification-testing-mode')

        if (savedCoins) {
          state.coins = parseInt(savedCoins, 10)
        }
        if (savedGems) {
          state.gems = parseInt(savedGems, 10)
        }
        if (savedReadBlogs) {
          try {
            state.readBlogs = JSON.parse(savedReadBlogs)
          } catch (e) {
            console.error('Error parsing read blogs:', e)
          }
        }
        if (savedTestingMode !== null) {
          state.testingMode = savedTestingMode === 'true'
        }
      }
    }
  }
})

export const {
  addCoins,
  addGems,
  deductGems,
  setGems,
  setCoins,
  markBlogAsRead,
  setTestingMode,
  syncFromStorage
} = gamificationSlice.actions

export default gamificationSlice.reducer
